import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { AddToBasketRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/AddToBasketRecommendationsFragmentDoc';
import { useHashParameters } from '@packages/modules/src/hooks/useHashParameters/useHashParameters';
import {
  CriteoProductsRecoSlider,
  PrudsysAddToBasketRecoSlider,
  SearchBasketToProductsRecoSlider,
} from '@packages/recommendations';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useIntl } from 'react-intl';
import { addToBasketRecommendationsMessages } from './messages';

/* GraphQL */ `
  fragment AddToBasketRecommendations on Product {
    akl
    availability {
      state
    }
    brand {
      name
    }
    defaultCategory
    hasSeries
    orderNumber
    price {
      value
    }
  }
`;

type AddToBasketRecommendationsProps = {
  data: FragmentType<typeof AddToBasketRecommendationsFragmentDoc>;
};

export const AddToBasketRecommendations = ({ data }: AddToBasketRecommendationsProps) => {
  const { formatMessage } = useIntl();
  const { category = '' } = useHashParameters();
  const {
    product: {
      recommendations: {
        atb: {
          slots: { '1': recoSlot1, '2': recoSlot2 },
        },
      },
    },
  } = useConfig();

  const { akl, brand, defaultCategory, orderNumber, hasSeries, price, availability } =
    getFragmentData(AddToBasketRecommendationsFragmentDoc, data);

  return (
    <>
      {
        {
          prudsysAddToBasket: (
            <PrudsysAddToBasketRecoSlider
              brand={brand?.name ?? ''}
              categoryIds={[defaultCategory ?? category]}
              productId={orderNumber}
              elementIndex={hasSeries ? 4 : 3}
              pageTemplate="detailview"
              title={formatMessage(addToBasketRecommendationsMessages.prudsysFallback)}
            />
          ),
          searchBasketToProducts: (
            <SearchBasketToProductsRecoSlider
              aklIds={[akl]}
              elementIndex={hasSeries ? 4 : 3}
              pageTemplate="detailview"
              title={formatMessage(addToBasketRecommendationsMessages.prudsysFallback)}
            />
          ),
        }[recoSlot1]
      }
      {recoSlot2 === 'criteoProducts' && (
        <CriteoProductsRecoSlider
          available={availability.state === 'NOT_AVAILABLE' ? 0 : 1}
          price={parseFloat(price.value.toFixed(2))}
          productId={orderNumber}
          fetchOnThreshold
          elementIndex={hasSeries ? 5 : 4}
          pageTemplate="detailview"
          title={formatMessage(addToBasketRecommendationsMessages.criteoFallback)}
          key={`${orderNumber}${2}`}
          brand={brand?.name ?? ''}
        />
      )}
    </>
  );
};
